import cn from "classnames";
import styles from "./Help.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../Icon";
import Item from "./Item";

const items = [];
const menu = [
    {
        title: "Membres d'équipe",
        icon: "profile-circle",
        arrow: true,
        url: "/admin/members",
    },
    // {
    //     title: "FAQ",
    //     icon: "help",
    //     arrow: true,
    //     url: "/partner/faq",
    // },
    {
        title: "Paramètres",
        icon: "setting",
        arrow: true,
        url: "/partner/settings",
    },
];

const Help = ({ className, visible, setVisible, onClose }) => {
    const handleClose = () => {
        onClose();
        setVisible(false);
    };

    return (
        <>
            <div
                className={cn(styles.help, className, {
                    [styles.active]: visible,
                })}
            >
                <div className={styles.head}>
                    <Icon name="help" size="24" />
                    Paramètres & Aides
                    <button
                        className={styles.close}
                        onClick={() => setVisible(false)}
                    >
                        <Icon name="close" size="24" />
                    </button>
                </div>
                <div className={styles.list}>
                    {items.map((x, index) => (
                        <Item className={styles.item} item={x} key={index} />
                    ))}
                </div>
                <div className={styles.menu}>
                    {menu.map((x, index) => (
                        <Link
                            className={styles.link}
                            to={x.url}
                            key={index}
                            onClick={() => handleClose()}
                        >
                            <Icon name={x.icon} size="24" />
                            {x.title}
                            {x.arrow && (
                                <div className={styles.arrow}>
                                    <Icon name="arrow-next" size="24" />
                                </div>
                            )}
                            {x.counter && (
                                <div className={styles.counter}>8</div>
                            )}
                        </Link>
                    ))}
                </div>
            </div>
            <div
                className={cn(styles.overlay, { [styles.active]: visible })}
                onClick={() => setVisible(false)}
            ></div>
        </>
    );
};

export default Help;
